declare global {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface Window {
        __bootstrapVersion?: 4 | 5;
        __bootstrapPrefix?: string;
    }
}

export function SetBootstrapVersion(version: 4 | 5) {
    window.__bootstrapVersion = version;
}

export function GetBootstrapVersion(): 4 | 5 | undefined {
    return window.__bootstrapVersion;
}

export function SetBootstrapPrefix(prefix: string) {
    window.__bootstrapPrefix = prefix;
}

export function GetBootstrapPrefix(): string {
    if (window.__bootstrapPrefix === undefined) {
        return '';
    }
    return window.__bootstrapPrefix;
}
